import * as types from './types';
import { execApiWithParam } from '../api/apiActions';
import { openSuccessDialog } from '../dialog/dialogActions';
import PasswordApi from '../../apis/password';


export const forgotPassword = (username, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.FORGOT_PASSWORD,
      api: PasswordApi.forgot,
      param: username,
      successCallback: () => {
        dispatch(openSuccessDialog({
          content: 'You will receive an email to reset your password. If the email isn\'t received within 1 hour contact the practice office.',
        }));

        if (successCb) successCb();
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: () => {
        if (errorCb) errorCb();
      },
      useErrorDialog: true,
    }));
  };
};

export const reset = (password, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.RESET_PASSWORD_REQUEST,
      api: PasswordApi.reset,
      param: password,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const checkResetToken = (password, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.RESET_PASSWORD_REQUEST,
      api: PasswordApi.checkResetToken,
      param: password,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: false,
    }));
  };
};


// WEBPACK FOOTER //
// ./src/actions/password/passwordActions.js